var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" 본 서비스의 아이디는 본인 휴대전화 번호 입니다. 본인 휴대전화번호가 변경 되셨을 경우, 기존 아이디 탈퇴 후 신규 가입 진행을 해주세요. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }